import React, { useState, useRef } from "react";
import useSupportManagement from "./useSupportManagement";

const TicketManagement = () => {
  const {
    tickets,
    modalData,
    message,
    setMessage,
    handleOpenModal,
    sendMessage,
    handleCloseTicket,submitSupportReview,
  } = useSupportManagement();

  const [activeTab, setActiveTab] = useState("All");
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [reviewTicketId, setReviewTicketId] = useState(null);
  const [hoverRating, setHoverRating] = useState(0);
  const [selectedRating, setSelectedRating] = useState(0);
  const [reviewComment, setReviewComment] = useState("");

  const openReviewModal = (ticketId) => {
    setReviewTicketId(ticketId);
    setShowReviewModal(true);
  };

  const handleSubmitReview = async (ticketId) => {
    if (!ticketId) return;
    if (selectedRating === 0) {
      alert("Please select a rating before submitting.");
      return;
    }
    try {
      await submitSupportReview({
        ticket_id: ticketId,
        rating: selectedRating,
        comment: reviewComment,
      });
      setSelectedRating(0);
      setReviewComment("");
      setHoverRating(0);
      setReviewTicketId(null);
      setShowReviewModal(false);
      await refreshTickets();
    } catch (err) {
      console.error("Failed to submit review", err);
    }
  };


  const filteredTickets =
    activeTab === "All" ? tickets : tickets.filter((t) => t.status === activeTab);

  const chatListRef = useRef(null);

  return (
    <div className="tm-container">
      <div className="card shadow-sm">
      <div className="card-body h-auto">
      <ul className="nav nav-tabs mb-3 nav nav-tabs custom-nav-tabs">
        {["All", "Open", "Resolved", "Closed","Pending"].map((status) => (
          <li className="nav-item" key={status}>
            <button
              className={`nav-link ${activeTab === status ? "active" : ""}`}
              onClick={() => setActiveTab(status)}
            >
              {status}
            </button>
          </li>
        ))}
      </ul>
        
          <div className="table-responsive table-responsive-height">
            <table className="tm-table table align-middle mb-0">
              <thead>
                <tr>
                  <th>Ticket ID</th>
                  <th>Title</th>
                  <th>Category</th>
                  <th>Status</th>
                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredTickets.length > 0 ? (
                  filteredTickets.map((t) => (
                    <tr key={t.id}>
                      <td>{t.id}</td>
                      <td>{t.title}</td>
                      <td>{t.category}</td>
                      <td>
                        <span
                          className={`badge ${
                            t.status === "Open"
                              ? "open-btn"
                              : t.status === "Resolved"
                              ? "resolved-btn"
                              : t.status === "Closed"
                              ? "closed-btn"
                              : t.status === "Pending" ? "pending-btn"
                              : "badge-secondary"
                          }`}
                        >
                          {t.status}
                        </span>
                      </td>
                      <td className="text-center">
                        <button
                          className="tm-action-btn"
                          title="View"
                          data-bs-toggle="modal"
                          data-bs-target={`#supportModal-Management`}
                          onClick={() => handleOpenModal(t)}
                        >
                          <i className="bi bi-eye"></i>
                        </button>
                        <div className="dropdown d-inline">
                          <button
                            className="tm-action-btn"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            title="More"
                          >
                            <i className="bi bi-three-dots-vertical"></i>
                          </button>
                          <ul className="dropdown-menu dropdown-menu-end">
                            {t.status !== "Resolved" && (
                              <li>
                                <a
                                  className="dropdown-item"
                                  onClick={() => handleCloseTicket(t.id)}
                                >
                                  Close Ticket
                                </a>
                              </li>
                            )}
                            <li>
                              <a className="dropdown-item text-danger" href="#">
                                Delete
                              </a>
                            </li>
                          </ul>

                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No tickets found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal */}
      <div
  className="modal fade tm-support-modal"
  id={`supportModal-Management`}
  tabIndex="-1"
  aria-hidden="true"
>
  <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg modal-coment">
    {modalData && (
      <div className="tm-support-card modal-content shadow">
        <div className="tm-support-header d-flex align-items-center">
          {/* {modalData.userImg && (
            <img
              src={modalData.userImg}
              alt={modalData.username}
              className="tm-support-avatar"
            />
          )} */}
          <div className="tm-support-usermeta ms-2">
            <div className="tm-support-heading">{modalData.username}</div>
            <div className="tm-support-role">{modalData.role}</div>
          </div>
          <button
            type="button"
            className="tm-close-btn-x ms-auto"
            aria-label="Close"
            data-bs-dismiss="modal"
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        <div className="px-4 py-3">
          <div className="p-3 rounded-4 bg-white shadow-sm d-flex flex-wrap align-items-center gap-4">
            {["ID", "Category", "Status"].map((label, i) => {
              let value;
              switch (label) {
                case "ID":
                  value = `${modalData.ticket}`;
                  break;
                case "Category":
                  value = modalData.category;
                  break;
                case "Status":
                  value = modalData.status;
                  break;
              }
              return (
                <div key={i} className="border-end pe-4 ticket-info-item">
                  <small className="text-secondary fw-medium d-block">{label}</small>                 
                    <span className="fw-semibold">{value}</span>
                </div>
              );
            })}
          </div>
        </div>

        {modalData.status === "Resolved" ? (
          <>
            <div className="modal-body text-center pt-0">
              <div className="mb-4 d-flex justify-content-center">
                {[1, 2, 3, 4, 5].map((n) => {
                  const isActive = n <= (hoverRating || selectedRating);
                  return (
                    <i
                      key={n}
                      className={`bi ${
                        isActive ? "bi-star-fill text-warning" : "bi-star text-muted"
                      } mx-1`}
                      style={{
                        fontSize: "2.5rem",
                        cursor: "pointer",
                        transition: "transform 0.2s, color 0.2s",
                      }}
                      onMouseEnter={() => setHoverRating(n)}
                      onMouseLeave={() => setHoverRating(0)}
                      onClick={() => setSelectedRating(n)}
                    />
                  );
                })}
              </div>

              <textarea
                className="form-control mb-3 rounded-3 shadow-sm border"
                rows={4}
                placeholder="Share your experience..."
                value={reviewComment}
                onChange={(e) => setReviewComment(e.target.value)}
                style={{ resize: "none" }}
              />
            </div>

            <div className="modal-footer modal-footer-support border-0 px-4 pb-4">
              <button
                className="btn btn-outline-secondary rounded-pill px-4"
                onClick={() => setShowReviewModal(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary rounded-pill px-4 shadow-sm"
                onClick={async () => {
                  await handleSubmitReview(modalData.ticket);
                  setShowReviewModal(false);
                }}
                disabled={selectedRating === 0}
                style={{
                  background: "linear-gradient(90deg, #0d6efd, #4dabf7)",
                  border: "none",
                }}
              >
                Submit Review
              </button>
            </div>
          </>
        ) : (
          <>
            <div
              className="tm-comment-list p-3"
              ref={chatListRef}
              style={{ maxHeight: "40vh", overflowY: "auto" }}
            >
              
              {modalData.chats?.map((msg, idx) => (
                <div key={idx} className="tm-comment-item">
                  {/* <img
                    src={msg.from === "user" ? modalData.userImg : "/assistant.png"}
                    alt={msg.from}
                    className="tm-comment-avatar"
                  /> */}
                  <div className="tm-comment-content">
                    <div className="tm-comment-header">
                      <span className="tm-comment-name">
                        {msg.from === "user" ? modalData.username : "Support Executive"}
                        <br />
                        <span className="tm-comment-time">
                          {msg.date} <span className="separator"></span> {msg.time}
                        </span>
                      </span>
                    </div>
                    <div className="tm-comment-text">{msg.text}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="tm-comment-footer">
              <input
                placeholder="Write a comment..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") sendMessage();
                }}
              />
              <button type="button" onClick={sendMessage}>
                <i className="bi bi-send"></i>
              </button>
            </div>
          </>
        )}
      </div>
    )}
  </div>
</div>

    </div>
  );
};

export default TicketManagement;
